import { render, staticRenderFns } from "./VentasModificador.vue?vue&type=template&id=62b77268"
import script from "./VentasModificador.vue?vue&type=script&lang=js"
export * from "./VentasModificador.vue?vue&type=script&lang=js"
import style0 from "./VentasModificador.vue?vue&type=style&index=0&id=62b77268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports